(function () {
  const mount = document.getElementById('silverchef-widget');
  if (!mount) return;

  // ── Config ───────────────────────────────────────────────
  const LOCALE       = mount.dataset.locale || 'en_CA';
  const TITLE        = mount.dataset.title  || 'Finance with Econolease';
  const BRAND_NAME   = mount.dataset.brand  || 'Econolease';
  const initialCents = Number(mount.dataset.cents || 0);

  const API_BASE = 'https://www.silverchef.finance/api/finance';
// CTA URL (opens in new tab)
const APPLY_URL = 'https://app.econolease.com/vancouver-restaurant-supply/apply?utm_source=vancouverrestaurantsupply&utm_medium=affiliate&utm_term=efsapplynow&utm_content=applynowweb&utm_campaign=dealership&lang=en-CA';
  // ── Inline SVG logo (fixed-size) ─────────────────────────
  const BRAND_LOGO_SVG = `
<svg class="scw-inline__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265 116" width="80" height="18" preserveAspectRatio="xMidYMid meet">
  <g>
    <path d="M57.693,116C42.282,116 27.794,109.999 16.898,99.102C6,88.205 0,73.718 0,58.307C0,42.897 6,28.409 16.898,17.512C39.391,-4.982 75.993,-4.982 98.488,17.512L99.902,18.926L97.074,21.754L95.66,20.34C74.723,-0.594 40.661,-0.592 19.726,20.34C9.584,30.482 4,43.965 4,58.307C4,72.649 9.584,86.132 19.726,96.274C29.868,106.415 43.351,112 57.693,112C72.035,112 85.518,106.415 95.66,96.274L97.074,94.86L99.902,97.688L98.488,99.102C87.591,109.999 73.103,116 57.693,116Z" fill="#3EBFB4"/>
    <path d="M247.87,58.959C248.366,55.894 250.399,53.815 253.739,53.815C257.031,53.815 258.747,55.85 258.747,58.959L247.87,58.959ZM254.055,49.258C246.834,49.258 242.366,54.675 242.366,61.311C242.366,67.852 246.698,72.997 253.963,72.997C257.935,72.997 261.092,71.417 263.532,68.572L260.644,65.28C259.288,67.04 257.075,68.256 254.503,68.256C250.623,68.256 248.322,65.733 247.962,62.98L264.164,62.98L264.164,60.631C264.164,53.455 260.459,49.258 254.055,49.258Z" fill="#030405"/>
    <path d="M184.281,58.959C184.777,55.894 186.81,53.815 190.149,53.815C193.442,53.815 195.159,55.85 195.159,58.959L184.281,58.959ZM190.466,49.258C183.245,49.258 178.776,54.675 178.776,61.311C178.776,67.852 183.109,72.997 190.374,72.997C194.346,72.997 197.503,71.417 199.943,68.572L197.055,65.28C195.698,67.04 193.486,68.256 190.914,68.256C187.033,68.256 184.733,65.733 184.373,62.98L200.575,62.98L200.575,60.631C200.575,53.455 196.871,49.258 190.466,49.258Z" fill="#030405"/>
    <path d="M45.348,72.467L45.348,42.136L64.592,42.136L64.592,46.892L51.077,46.892L51.077,54.459L64.592,54.459L64.592,59.215L51.077,59.215L51.077,67.71L64.592,67.71L64.592,72.467L45.348,72.467Z" fill="#030405"/>
    <path d="M77.941,72.997C71.17,72.997 66.442,68.122 66.442,61.144C66.442,54.387 71.462,49.291 78.118,49.291C81.113,49.291 83.657,50.152 85.886,51.92L83.021,55.806C81.676,54.638 80.25,54.092 78.56,54.092C74.968,54.092 72.259,57.123 72.259,61.144C72.259,65.164 74.93,68.195 78.471,68.195C80.261,68.195 81.641,67.692 82.898,66.569L85.885,70.38C83.77,72.164 81.237,72.997 77.941,72.997Z" fill="#030405"/>
    <path d="M97.356,54.092C93.833,54.092 91.276,57.057 91.276,61.144C91.276,65.23 93.833,68.195 97.356,68.195C100.855,68.195 103.393,65.23 103.393,61.144C103.393,57.057 100.855,54.092 97.356,54.092ZM97.356,72.997C90.574,72.997 85.459,67.901 85.459,61.144C85.459,54.387 90.574,49.291 97.356,49.291C104.114,49.291 109.21,54.387 109.21,61.144C109.21,67.901 104.114,72.997 97.356,72.997Z" fill="#030405"/>
    <path d="M126.563,72.467L126.563,61.011C126.563,59.167 126.507,57.251 125.825,55.889C125.238,54.713 124.078,54.092 122.471,54.092C120.398,54.092 118.294,55.846 117.155,57.731L117.141,57.999L117.141,72.467L111.457,72.467L111.457,49.821L116.665,49.821L116.9,53.469L117.321,52.877C118.944,50.599 121.481,49.291 124.282,49.291C126.599,49.291 128.768,50.362 130.233,52.227C131.905,54.387 132.247,57.177 132.247,60.702L132.247,72.467L126.563,72.467Z" fill="#030405"/>
    <path d="M146.501,54.092C142.978,54.092 140.421,57.057 140.421,61.144C140.421,65.23 142.978,68.195 146.501,68.195C149.999,68.195 152.537,65.23 152.537,61.144C152.537,57.057 149.999,54.092 146.501,54.092ZM146.501,72.997C139.718,72.997 134.604,67.901 134.604,61.144C134.604,54.387 139.718,49.291 146.501,49.291C153.259,49.291 158.354,54.387 158.354,61.144C158.354,67.901 153.259,72.997 146.501,72.997Z" fill="#030405"/>
    <path d="M160.629,72.467L160.629,42.136L166.358,42.136L166.358,67.71L179.035,67.71L179.035,72.467L160.629,72.467Z" fill="#030405"/>
    <path d="M213.037,61.954C210.482,61.954 207.751,62.97 207.751,65.826C207.751,68.152 209.736,69.211 211.58,69.211C213.29,69.211 214.872,68.536 216.413,67.148L216.511,67.06L216.511,62.399L216.281,62.358C215.038,62.082 214.007,61.954 213.037,61.954ZM210.254,72.997C206.375,72.997 202.2,70.78 202.2,65.914C202.2,59.22 209.717,58.699 212.02,58.699C213.248,58.699 214.678,58.866 216.156,59.179L216.511,59.254L216.511,58.538C216.511,55.189 214.912,53.562 211.623,53.562C208.936,53.562 206.57,54.552 204.76,55.474L203.291,51.53C206.315,50.085 209.719,49.291 212.904,49.291C218.896,49.291 222.195,52.67 222.195,58.803L222.195,72.467L216.977,72.467L216.715,70.126L216.341,70.587C215.047,72.186 213,72.997 210.254,72.997Z" fill="#030405"/>
    <path d="M232.615,72.997C229.263,72.997 226.174,71.723 223.665,69.309L226.836,66.021C228.575,67.682 230.064,68.637 232.306,68.637C233.883,68.637 235.559,67.822 235.559,66.311C235.559,64.668 233.786,63.903 231.732,63.018L230.967,62.686C228.104,61.459 225.311,59.942 225.311,56.109C225.311,51.425 229.464,49.291 233.322,49.291C236.277,49.291 238.906,50.249 240.946,52.065L237.89,55.434C236.981,54.675 235.34,53.606 233.322,53.606C231.846,53.606 230.775,54.473 230.775,55.667C230.775,57.369 232.732,58.169 234.624,58.943L234.751,58.994C237.643,60.185 241.244,61.668 241.244,65.826C241.244,70.779 236.91,72.997 232.615,72.997Z" fill="#030405"/>
  </g>
</svg>`.trim();

  // ── Critical CSS injection ───────────────────────────────
  (function ensureStyles() {
    const ID = 'scw-critical-css';
    if (document.getElementById(ID)) return;
    const css = `
    /* CTA */
#scw-modal-overlay .scw__cta-wrap{margin-top:14px;text-align:center}
#scw-modal-overlay .scw__cta{
  display:inline-block;padding:12px 18px;border-radius:8px;
  background:#3EBFB4;color:#fff;text-decoration:none;font-weight:700;
}
#scw-modal-overlay .scw__cta:focus{outline:2px solid #004f49;outline-offset:2px}
#scw-modal-overlay .scw__cta:hover{filter:brightness(0.95)}

/* Teaser */
.scw-inline{margin-top:8px}
.scw-inline__line{display:flex;align-items:center;flex-wrap:wrap;column-gap:8px;row-gap:4px;font-size:14px;line-height:1.25}
.scw-inline__left { gap: 0; }
.scw-inline__logo{width:45px;display:inline-block;vertical-align:middle}
.scw-inline__link{background:0;border:0;padding:0;text-decoration:underline;cursor:pointer;font:inherit;color:inherit;white-space:nowrap;margin-left:0;flex:0 0 auto}
@media (max-width:400px){.scw-inline__line{font-size:13px}}

/* Modal */
.scw-modal-open{overflow:hidden}
#scw-modal-overlay{position:fixed;inset:0;display:none;background:rgba(0,0,0,.55);z-index:2147483646}
#scw-modal-overlay.is-open{display:block}

/* Centered dialog >1280px */
#scw-modal-overlay .scw-modal{
  position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);
  width:min(720px,92vw);max-height:86vh;overflow:auto;
  background:#fff;border-radius:12px;box-shadow:0 10px 40px rgba(0,0,0,.25);
  padding:16px 16px 18px;box-sizing:border-box
}
/* Bottom sheet ≤1280px */
@media (max-width:1280px){
  #scw-modal-overlay .scw-modal{
    left:0;right:0;bottom:0;top:auto;transform:none;width:100vw;max-height:88dvh;border-radius:16px 16px 0 0
  }
}

#scw-modal-overlay .scw-modal__close{position:absolute;right:10px;top:8px;border:0;background:none;font-size:24px;line-height:1;cursor:pointer}
#scw-modal-overlay .scw-modal__head{margin:4px 8px 12px}
#scw-modal-overlay .scw-modal__title{font-weight:700;font-size:18px;margin-bottom:2px}
#scw-modal-overlay .scw-modal__sub{font-size:14px;opacity:.9}
#scw-modal-overlay .scw-modal__sub strong{font-size:16px}

/* Cards/grid */
#scw-modal-overlay .scw__grid{display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(240px,1fr))}
#scw-modal-overlay .scw__card{border:1px solid #e6e6e6;border-radius:10px;padding:10px;background:#fff;box-sizing:border-box}
#scw-modal-overlay .scw__plan{font-weight:600;margin-bottom:6px}
#scw-modal-overlay .scw__price{font-size:16px;font-weight:600;margin:4px 0 6px}
#scw-modal-overlay .scw__row{display:flex;justify-content:space-between;gap:12px;padding:2px 0}
#scw-modal-overlay .scw__row span:last-child{font-variant-numeric:tabular-nums}
#scw-modal-overlay .scw__list{display:grid;grid-template-columns:1fr auto;gap:4px 12px}
#scw-modal-overlay .scw__list>div{display:contents}
#scw-modal-overlay .scw__table{display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px 8px}
#scw-modal-overlay .scw__tr{display:contents}
#scw-modal-overlay .scw__tr--head>div{font-weight:600}
#scw-modal-overlay .scw__foot{margin-top:10px;opacity:.8}
    `.trim();
    const style = document.createElement('style');
    style.id = ID;
    style.textContent = css;
    document.head.appendChild(style);
  })();

  // ── Helpers ──────────────────────────────────────────────
  const fmtCAD = (n) => new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(n||0);
  const moneyToNumber = (s) => (typeof s==='number'?s:Number(String(s||'').replace(/[^0-9.-]+/g,''))||0);

  function renderLoading(){ mount.innerHTML=`<div class="scw"><div class="scw__loading"></div>Fetching financing options from EconoLease.</div>` }
  function renderError(msg){ mount.innerHTML=`<div class="scw scw--error">${msg||''}</div>` }

  // ── Teaser + Modal ───────────────────────────────────────
  function renderPlans(api,productAmount){
    const weeklyStr  = api.weekly_amount || api.after_contract_options?.rent?.weekly_amount || null;
    const monthlyStr = api.monthly_amount ? api.monthly_amount
      : (weeklyStr ? fmtCAD(Math.round(moneyToNumber(weeklyStr)*(52/12)*100)/100) : null);

    const brandEl = BRAND_LOGO_SVG || `<span class="scw-inline__brand">${BRAND_NAME}</span>`;

    const teaserHTML = `
      <div class="scw scw-inline" aria-live="polite">
        <div class="scw-inline__line">
          <div class="scw-inline__left">
            <span>From <strong>${weeklyStr ||'—'}</strong>/week with</span>
            ${brandEl}
          </div>
          <button type="button" class="scw-inline__link" data-scw-open>View sample plans</button>
        </div>
      </div>
    `;
    mount.innerHTML = teaserHTML;
    mount.querySelector('[data-scw-open]')?.addEventListener('click',()=>openSCWModal(buildDetailsHTML(api,productAmount)));
  }

  function buildDetailsHTML(api, amount) {
    const has = (obj, path) => path.split('.').every(k => (obj = (obj || {})[k]) !== undefined);

    const weekly        = api.weekly_amount || '';
    const financeAmount = api.finance_amount || '';

    const upfrontTotal = has(api,'upfront_costs.total') ? api.upfront_costs.total : '';
    const advance      = has(api,'upfront_costs.breakdown.advance_payment') ? api.upfront_costs.breakdown.advance_payment : '';
    const bond         = has(api,'upfront_costs.breakdown.bond') ? api.upfront_costs.breakdown.bond : '';

    const rentAfter12  = has(api,'totals.rent_after_12_months') ? api.totals.rent_after_12_months : '';
    const outOfPocket  = has(api,'totals.out_of_pocket') ? api.totals.out_of_pocket : '';
    // FOR Net Ownership add ${(netOwnAmt || netOwnPct) ? `<div class="scw__row"><span>Net ownership cost</span><span>${[netOwnAmt, netOwnPct].filter(Boolean).join(' · ')}</span></div>` : ``}
    const purchasePrice  = has(api,'after_contract_options.purchase.purchase_price') ? api.after_contract_options.purchase.purchase_price : '';
    const totalOwnership = has(api,'after_contract_options.purchase.total_ownership_cost') ? api.after_contract_options.purchase.total_ownership_cost : '';
    const netOwnAmt      = has(api,'after_contract_options.purchase.net_ownership_cost.amount') ? api.after_contract_options.purchase.net_ownership_cost.amount : '';
    const netOwnPct      = has(api,'after_contract_options.purchase.net_ownership_cost.percent') ? api.after_contract_options.purchase.net_ownership_cost.percent : '';

    const rentWeekly   = has(api,'after_contract_options.rent.weekly_amount') ? api.after_contract_options.rent.weekly_amount : '';
    const extendWeekly = has(api,'after_contract_options.extend.weekly_amount') ? api.after_contract_options.extend.weekly_amount : '';
    const extendDisc   = has(api,'after_contract_options.extend.discount_amount') ? api.after_contract_options.extend.discount_amount : '';

    const leaseOptions = has(api,'after_contract_options.lease.options') ? (api.after_contract_options.lease.options || []) : [];

    return `
      <div class="scw-modal__head">
        <div class="scw-modal__title">Finance with Econolease</div>
        <div class="scw-modal__sub">
          ${weekly ? `<strong>${weekly}</strong> per week` : ``}
          ${financeAmount ? `<div class="scw-modal__foot">Finance amount ${financeAmount}</div>` : ``}
        </div>
      </div>

      <div class="scw__grid">
        ${(upfrontTotal || advance || bond) ? `
          <div class="scw__card">
            <div class="scw__plan">Upfront today</div>
            ${upfrontTotal ? `<div class="scw__price">${upfrontTotal}</div>` : ``}
            <div class="scw__list">
              ${advance ? `<div><span>Advance payment</span><span>${advance}</span></div>` : ``}
              ${bond ? `<div><span>Bond</span><span>${bond}</span></div>` : ``}
            </div>
          </div>` : ``}

        ${(rentAfter12 || outOfPocket) ? `
          <div class="scw__card">
            <div class="scw__plan">Totals (first 12 months)</div>
            ${rentAfter12 ? `<div class="scw__row"><span>Rent paid</span><span>${rentAfter12}</span></div>` : ``}
            ${outOfPocket ? `<div class="scw__row"><span>Out of pocket</span><span>${outOfPocket}</span></div>` : ``}
          </div>` : ``}

        ${(purchasePrice || totalOwnership || netOwnAmt || netOwnPct) ? `
          <div class="scw__card">
            <div class="scw__plan">Purchase after 12 months</div>
            ${purchasePrice  ? `<div class="scw__row"><span>Purchase price</span><span>${purchasePrice}</span></div>` : ``}
            ${totalOwnership ? `<div class="scw__row"><span>Total ownership cost</span><span>${totalOwnership}</span></div>` : ``}
          </div>` : ``}

        ${(extendWeekly || extendDisc || rentWeekly) ? `
          <div class="scw__card">
            <div class="scw__plan">Keep renting / extend</div>
            ${rentWeekly   ? `<div class="scw__row"><span>Rent (same terms)</span><span>${rentWeekly}/week</span></div>` : ``}
            ${(extendWeekly || extendDisc) ? `<div class="scw__row"><span>Extend</span><span>${[extendWeekly && `${extendWeekly}/week`, extendDisc && `${extendDisc} discount`].filter(Boolean).join(' · ')}</span></div>` : ``}
          </div>` : ``}

        ${leaseOptions.length ? `
          <div class="scw__card">
            <div class="scw__plan">Lease options</div>
            <div class="scw__table">
              <div class="scw__tr scw__tr--head"><div>Length</div><div>Discount</div><div>Weekly</div></div>
              ${leaseOptions.map(o => `
                <div class="scw__tr">
                  <div>${(o.length ?? '')} mo</div>
                  <div>${o.discount ?? ''}</div>
                  <div>${o.weekly_rent ?? ''}</div>
                </div>`).join('')}
            </div>
          </div>` : ``}
      </div>

      <div class="scw__foot">Based on price ${fmtCAD(amount)}</div>
      <div class="scw__cta-wrap">
  <a class="scw__cta"
     href="${APPLY_URL}"
     target="_blank"
     rel="noopener noreferrer"
     aria-label="Apply for financing with ${BRAND_NAME}">
    Apply Now
  </a>
</div>

    `;
  }

  // Modal open/close + keyboard support
  function openSCWModal(innerHTML) {
    let overlay = document.querySelector('#scw-modal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'scw-modal-overlay';
      overlay.innerHTML = `
        <div class="scw-modal" role="dialog" aria-modal="true" aria-label="${TITLE}">
          <button type="button" class="scw-modal__close" aria-label="Close">×</button>
          <div class="scw-modal__content"></div>
        </div>
      `;
      document.body.appendChild(overlay);

      overlay.addEventListener('click', (e) => { if (e.target === overlay) closeSCWModal(); });
      overlay.querySelector('.scw-modal__close').addEventListener('click', closeSCWModal);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSCWModal(); });
    }
    overlay.querySelector('.scw-modal__content').innerHTML = innerHTML;
    document.documentElement.classList.add('scw-modal-open');
    overlay.classList.add('is-open');
    overlay.querySelector('.scw-modal__close')?.focus();
  }
  function closeSCWModal() {
    document.documentElement.classList.remove('scw-modal-open');
    document.querySelector('#scw-modal-overlay')?.classList.remove('is-open');
  }

  // ── Fetch SilverChef calculator ──────────────────────────
  async function fetchPlansFromCents(totalCents) {
    const cents = Math.max(0, Math.round(Number(totalCents) || 0));
    if (!cents) return renderError('');

    renderLoading();

    // URL: /api/finance/{locale}/calculator/{dollars}/[{cents}/]
    const dollarsPart = Math.floor(cents / 100);
    const centsPart   = cents % 100;
    const url = centsPart
      ? `${API_BASE}/${encodeURIComponent(LOCALE)}/calculator/${dollarsPart}/${String(centsPart).padStart(2,'0')}/`
      : `${API_BASE}/${encodeURIComponent(LOCALE)}/calculator/${dollarsPart}/`;

    try {
      const res = await fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      renderPlans(data, cents / 100);
    } catch (err) {
      console.error('SilverChef widget error:', err);
      renderError('Please try again in a moment.');
    }
  }

  // Initial + variant change hooks
  fetchPlansFromCents(initialCents);

  document.addEventListener('variant:change', (e) => {
    const cents = e?.detail?.variant?.price;
    if (typeof cents === 'number') fetchPlansFromCents(cents);
  });

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('select[name="id"]');
    if (!sel) return;

    let cents = null;
    if (window?.ShopifyAnalytics?.meta?.product?.variants) {
      const id = Number(sel.value);
      const v = window.ShopifyAnalytics.meta.product.variants.find(x => Number(x.id) === id);
      cents = v?.price;
    }
    if (!cents) {
      const script = document.querySelector('script[type="application/json"][data-product]');
      if (script) {
        try {
          const product = JSON.parse(script.textContent);
          const id = Number(sel.value);
          const v = product?.variants?.find(x => Number(x.id) === id);
          cents = v?.price;
        } catch (_) {}
      }
    }
    if (typeof cents === 'number') fetchPlansFromCents(cents);
  });
})();
